// Manage Edit Team
import { manageEditTeam, manageEditTeamConfig } from './manage.editTeam.js'

export default function editTeamRoutes($stateProvider) {
  'ngInject'
  $stateProvider.state(manageEditTeam, manageEditTeamConfig)
}
